import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filter'
})
export class SearchPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var rVal;
    if (!args) {
      return value;
    }
    return value.filter((val) => {
      // pages , menu
      if (val.name) {
        rVal = val.name.toLowerCase().includes(args);
      }
      // posts
      if (val.title) {
        rVal = val.title.toLowerCase().includes(args);
      }
      // media
      if (val.filename) {
        rVal = val.filename.toLowerCase().includes(args);
      }


      return rVal;
    });
  }
}



import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml'
})
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) { }

  transform(v) {
    return this._sanitizer.bypassSecurityTrustHtml(v);

  }
}



@Pipe({
  name: 'userType'
})
export class userTypePipe implements PipeTransform {

  constructor() { }

  transform(value: any, args?: any) {
    switch (value) {
      case 1:
        return 'Admin';
      case 2:
        return 'Customer';
      case 3:
        return 'GuestClient';
      case 4:
        return 'Employee';
      default:
        return value;
    }

  }
}

@Pipe({
  name: 'notificationType'
})
export class notificationTypePipe implements PipeTransform {

  constructor() { }

  transform(value: any, args?: any) {
    switch (value) {
      case 1:
        return 'Email';
      case 2:
        return 'SMS';
      case 3:
        return 'Mobile Notification';
      default:
        return value;
    }

  }
}

@Pipe({
  name: 'SeverityType'
})
export class SeverityPipe implements PipeTransform {

  constructor() { }

  transform(value: any, args?: any) {
    switch (value) {
      case 0:
        return 'Info';
      case 1:
        return 'Success';
      case 2:
        return 'Warn';
      default:
        return value;
    }

  }
}
